import {
  USER_LOGIN_R,
  USER_LOGOUT_R,
  RESTORE_USER_BY_TOKEN_R,
  USER_COGNITO_LOGIN_R,
  CHANGE_VIEW,
  MODAL_CHANGE,
  USERS_R,
  ROLES_R,
  UPDATE_ROLES_R
} from 'constants/actionTypes';

export const changeModal = (modalName, data) => ({
  type: MODAL_CHANGE,
  payload: {
    modalName,
    data
  }
});

export const login = (code) => ({
  type: USER_LOGIN_R,
  payload: {
    code
  }
});

export const cognitoLogin = () => ({
  type: USER_COGNITO_LOGIN_R
});

export const logout = () => ({
  type: USER_LOGOUT_R
});

export const restoreUserByToken = (next) => ({
  type: RESTORE_USER_BY_TOKEN_R,
  payload: {
    next
  }
});

export const changeView = (view) => ({
  type: CHANGE_VIEW,
  payload: {
    view
  }
});

export const getUsers = () => ({
  type: USERS_R
});

export const getRoles = () => ({
  type: ROLES_R
});

export const updateRoles = (value, recordKey) => ({
  type: UPDATE_ROLES_R,
  payload: {
    value,
    recordKey
  }
});
